import config from '@/config';
import contact from './contact';
import marketing from './marketing';
import topNav from './topNav';
// eslint-disable-next-line import/named
import { defaultAutomation, cainiaoAutomation, automationFlow } from './automation';
import analysis from './analysis';
import channels from './channels';
import setting from './setting';

const { siteConfig } = config;
const isCustomizedRoute = siteConfig.brand && ['cninbox'].includes(siteConfig.key || '') && false;

export default [
    {
        path: 'home',
        name: 'index_home',
        meta: {
            title: 'index_home',
            icon: 'icon-shouye',
            access: ['AUTH_HOME_PAGE'],
        },
        component: () => import('@/views/main/home/index.vue'),
    },
    {
        path: 'idle',
        name: 'idle',
        meta: {
            title: 'Idle',
            hideInMenu: true,
            hideInBread: true,
        },
        component: () => import(/* webpackChunkName: "combind" */'@/views/main/Idle.vue'),
    },
    {
        path: 'chat',
        name: 'authMode_chat',
        meta: {
            access: ['AUTH_MESSENGER_CHAT'],
            title: 'authMode_chat',
            icon: 'icon-liaotian',
        },
        component: () => import('@/views/main/authMode/Chat/index.vue'),
    },
    ...contact,
    ...marketing,
    automationFlow,
    isCustomizedRoute ? cainiaoAutomation : defaultAutomation,
    ...analysis,
    ...channels,
    /** 此路由要替换的文件较多，保留原路径进行兼容 start */
    {
        path: 'appstore',
        name: 'old_appstore',
        meta: {
            access: ['AUTH_APPLICATION_CENTER'],
            title: 'appstore',
            hideInMenu: true,
            notPageView: true,
        },
        redirect: { name: 'appstore' },
    },
    /**  end */
    {
        path: 'fee',
        name: 'fee',
        meta: {
            access: ['AUTH_SETTING_COST_CENTER'],
            title: 'authMode_setting_fee',
            icon: 'icon-fee',
        },
        component: () => import('@/views/main/setting/Fee/index.vue'),
    },
    ...setting,
    ...topNav,
];
